/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createSetupIntentDataSchema = z.object({
	profileId: z.string().uuid(),
})

export type CreateSetupIntentDataSchema = z.infer<typeof createSetupIntentDataSchema>
